import { GetStaticProps } from "next";
import { VFC } from "react";
import { PageHeader, SEO } from "~/components";
import { useTranslation } from "~/hooks";
import { Products } from "~/layouts";
import { fetchProducts, Product } from "~/lib/server/microcms";

type Props = {
  products: Product[];
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const products = await fetchProducts();
  return {
    props: {
      products: products
    },
    revalidate: 60
  };
};

const ProductsPage: VFC<Props> = ({ products }) => {
  const { dic } = useTranslation();
  return (
    <Products>
      <SEO pageName="取り扱い商品" path="/products" />
      <PageHeader
        labelText="Products"
        headingText={dic.navigation.products}
        crumbs={[
          {
            label: dic.homepage,
            path: "/"
          },
          {
            label: dic.navigation.products
          }
        ]}
      />
      <Products.List>
        {products.map((item) => (
          <Products.Item key={item.id} product={item} />
        ))}
      </Products.List>
    </Products>
  );
};

export default ProductsPage;
